import { render, staticRenderFns } from "./ToznySwitch.vue?vue&type=template&id=2b7ad9fb&scoped=true&"
import script from "./ToznySwitch.vue?vue&type=script&lang=js&"
export * from "./ToznySwitch.vue?vue&type=script&lang=js&"
import style0 from "./ToznySwitch.vue?vue&type=style&index=0&id=2b7ad9fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ad9fb",
  null
  
)

export default component.exports